import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Input, Modal, Row } from "reactstrap";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import { connect, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { changePreloader } from "../../store/actions";
import '../Orders/styles/AllOrders.scss';
import { formatNumberWithCommasAndDecimal } from "./invoiceUtil";
/*.dropdown-toggle::after {
  display: none !important; 
}*/

//Import Action to copy breadcrumb items from local state to redux state
import * as XLSX from 'xlsx';
import StyledButton from "../../components/Common/StyledButton";
import useAuth from "../../hooks/useAuth";
import RequireUserType from "../../routes/middleware/requireUserType";
import { getInvoicesReq } from "../../service/invoiceService";
import { setBreadcrumbItems } from "../../store/Breadcrumb/actions";
import { USER_TYPES_ENUM } from "../../utility/constants";
import { formatDate } from "../../utility/formatDate";
import InvoiceStatusRenderer from "../Orders/InvoiceStatusRenderer";
import InvoiceActionBtn from "./InvoiceActionBtn";
import { getDateInFormat, getDifferenceInDays, ifOverDue } from "./invoiceUtil";
import "./styles/AllInvoices.scss";
import "./styles/datatables.scss";

const AllInvoices = (props) => {
  document.title = "Invoices";
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const effectCalled = useRef(false);
  const [sortBody, setSortBody] = useState({
    key: 'date',
    order: "D"
  });
  const [isExporting, setIsExporting] = useState(false);
  const { auth } = useAuth();

  const redirectToViewPage = (id) => {
    let path = "/view-invoice/" + id;
    setTimeout(() => {
      navigate(path, id);
    }, 400);
  };

  const redirectToEditPage = (id) => {
    // let path = "/Edit-invoice/"+id;
    //  setTimeout(() => {
    //   navigate(path, id);
    //  }, 400);
  };

  const parseDateToISOStart = (dateStr) => {
    if (!dateStr) return null;

    if (dateStr.includes('-')) {
      return new Date(`${dateStr}T00:00:00.000Z`).toISOString();
    }

    if (dateStr.includes('/')) {
      const [day, month, year] = dateStr.split('/');
      return new Date(`${year}-${month}-${day}T00:00:00.000Z`).toISOString();
    }

    return null;
  };

  const parseDateToISOEnd = (dateStr) => {
    if (!dateStr) return null;

    if (dateStr.includes('-')) {
      return new Date(`${dateStr}T23:59:59.999Z`).toISOString();
    }

    if (dateStr.includes('/')) {
      const [day, month, year] = dateStr.split('/');
      return new Date(`${year}-${month}-${day}T23:59:59.999Z`).toISOString();
    }

    return null;
  };

  const notify = (type, message) => {
    if (type === "Error") {
      toast.error(message, {
        position: "top-center",
        theme: "colored",
      });
    } else {
      toast.success(message, {
        position: "top-center",
        theme: "colored",
      });
    }
  };
  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "Invoices", link: "#" },
  ];
  const gridRef = useRef();
  const handleDeleteResponse = (response) => {
    if (response.success === true) {
      notify("Success", response.message);
    } else {
      notify("Error", response.message);
    }
    setmodal_standard(false);
    getListOfRowData();
  };
  const handleEditClick = (id) => {
    console.log("GRID OBJECT >>>" + id);
    redirectToEditPage(id);
  };

  const onClickView = (id) => {
    console.log("GRID OBJECT >>>" + id);
    redirectToViewPage(id);
  };

  const headerTemplate = (props) => {
    const { handleSort, data } = props
    return (
      <button onClick={() => handleSort(data, sortBody)} style={{ background: 'transparent', border: 'none' }}>
        <span style={{ fontWeight: 600 }}>
          {data?.displayName}&nbsp;
          {sortBody?.key === data?.column.userProvidedColDef.field ? <i className={sortBody?.order === "A" ? "mdi mdi-arrow-up" : "mdi mdi-arrow-down"}></i> : ''}
        </span>
      </button>
    )
  }

  const handleSort = (data, sortBody) => {
    if (data.column.userProvidedColDef.field === sortBody?.key) {
      setSortBody({ ...sortBody, order: sortBody?.order === "A" ? "D" : "A" })
    } else {
      setSortBody({
        key: data.column.userProvidedColDef.field,
        order: "D"
      })
    }
    setPage(1)
    setRowData([])
  }

  const columnDefs = [
    {
      headerName: "Invoice Date",
      field: "date", minWidth: 140,
      cellRenderer: (props) => {
        if (props.value) {
          let date = new Date(props.value);
          return <>{formatDate(date)}</>;
        }
      },
      suppressMenu: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      sortable: false,
      headerComponent: headerTemplate,
      headerComponentParams: (props) => ({
        handleSort: handleSort,
        data: props,
        sortBody,
      })
    },
    {
      headerName: "Invoice No.",
      field: "invoice_number",
      tooltipField: "invoice_number",
      suppressMenu: true, minWidth: 150,
      floatingFilterComponentParams: { suppressFilterButton: true },
      sortable: false,
      headerComponent: headerTemplate,
      headerComponentParams: (props) => ({
        handleSort: handleSort,
        data: props,
        sortBody,
      })
    },
    {
      headerName: "Order No.",
      field: "reference_number",
      suppressMenu: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      sortable: false,
    },
    {
      headerName: "Client",
      field: "customer_name",
      tooltipField: "customer_name",
      suppressMenu: true, minWidth: 150, flex: 1,
      floatingFilterComponentParams: { suppressFilterButton: true },
      sortable: false,
      headerComponent: headerTemplate,
      headerComponentParams: (props) => ({
        handleSort: handleSort,
        data: props,
        sortBody,
      })
    },
    {
      headerName: "Status",
      field: "status",
      tooltipField: "status",
      cellRenderer: InvoiceStatusRenderer,
      suppressMenu: true, minWidth: 100, flex: 1,
      floatingFilterComponentParams: { suppressFilterButton: true },
      sortable: false,
    },
    {
      headerName: "Due Date",
      field: "due_date",
      minWidth: 150,
      cellRenderer: (props) => {
        if (props?.data?.due_date) {
          let due_date = new Date(props.data.due_date);

          let curr_date = new Date();
          let status_msg = "";
          let statusClass = "status-msg ";
          if (ifOverDue(curr_date, due_date)) {
            let days = getDifferenceInDays(curr_date, due_date);
            status_msg = days > 0 ? "Overdue by " + days + " day(s)" : "";
            statusClass = statusClass + "red";
          } else {
            let days = getDifferenceInDays(curr_date, due_date);

            days > 0
              ? (status_msg = "Pending in " + days + " day(s)")
              : (status_msg = "");

            statusClass = statusClass + "green";
          }
          return (
            <>
              <p className="status-field">{getDateInFormat(due_date)}</p>
              <p className={statusClass}>{status_msg}</p>{" "}
            </>
          );
        }
      },
      suppressMenu: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      sortable: false,
    },
    {
      headerName: "Total Amount",
      field: "total",
      sortable: false,
      suppressMenu: true, minWidth: 140,
      floatingFilterComponentParams: { suppressFilterButton: true },
      valueFormatter: (params) =>
        formatNumberWithCommasAndDecimal(params.value),
      headerComponent: headerTemplate,
      headerComponentParams: (props) => ({
        handleSort: handleSort,
        data: props,
        sortBody,
      })
    },
    {
      headerName: "Amount Due",
      field: "balance",
      suppressMenu: true, minWidth: 140,
      floatingFilterComponentParams: { suppressFilterButton: true },
      sortable: false,
      valueFormatter: (params) =>
        formatNumberWithCommasAndDecimal(params.value),
    },
    {
      headerName: "Action",
      field: "action",
      sortable: false, width: 100,
      cellClass: "actions-button-cell",
      cellRenderer: InvoiceActionBtn,
      cellRendererParams: {
        onClickView: onClickView,
      },
      suppressMenu: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
    },
  ];

  const clientColumnDefs = columnDefs.filter(colDef => colDef.headerName !== "Client")

  const autoSizeStrategy = {
    type: "fitGridWidth",
  };
  // enables pagination in the grid
  const pagination = true;

  // sets 10 rows per page (default is 100)
  // allows the user to select the page size from a predefined list of page sizes
  const paginationPageSizeSelector = [25, 50, 100];

  const [allCustomers, setAllCustomers] = useState([]);
  const [customer, setCustomer] = useState("");
  const [rowData, setRowData] = useState([]);
  const [searchValue, setSearchValue] = useState();

  const [paginationPageSize, setPaginationPageSize] = useState(25);
  const [page, setPage] = useState(1);
  const [currRowItem, setCurrRowItem] = useState(null);
  const [modal_standard, setmodal_standard] = useState(false);
  const [delaySearch, setDelaySearch] = useState();
  const [inputValue, setInputValue] = useState('');
  const [exportOpen, setExportOpen] = useState(false);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');


  const tog_standard = () => {
    setmodal_standard(!modal_standard);
    removeBodyCss();
  };
  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  const onPaginationChanged = useCallback((event) => {
    // Workaround for bug in events order
    let pageSize = gridRef.current.api.paginationGetPageSize();
    setPaginationPageSize(pageSize);

    if (pageSize !== paginationPageSize) {
      setPaginationPageSize(pageSize);
    }
    const newPage = gridRef.current.api.paginationGetCurrentPage() + 1;

    if (page !== newPage) {
      setPage(newPage);
    }
  }, []);
  /*
{
    "page": 1,
    "limit": 10,
    "search": "p",
    "sort": {
        "key": "createdAt",
        "order": "asc"
    },
    "filter": {
        "category": "65bab211ce0f79d56447c537"
    }
}
* */
  const getListOfRowData = useCallback(async (body) => {
    if (rowData[(page - 1) * paginationPageSize]) {
      return;
    }
    dispatch(changePreloader(true));
    try {
      const response = await getInvoicesReq(body);

      let custList = new Set();
      response.map((val, id) => {
        custList.add(val.customer_name);
      });
      let custArr = [];

      custList?.forEach((val, key, set) => {
        custArr.push(val);
      });

      const emptyObjects = Array.from({ length: paginationPageSize }, () => (null));
      let filledRows;

      if (response.length < paginationPageSize) {
        filledRows = [...response];
      } else {
        filledRows = [...response, ...emptyObjects];
      }

      const newData = [...rowData];
      newData.splice((page - 1) * paginationPageSize, paginationPageSize, ...filledRows);

      setAllCustomers([...custArr]);
      setRowData(newData);
    } catch (error) {
      console.error("Error fetching purchase orders:", error);
    } finally {
      dispatch(changePreloader(false));
    }
  }, [page, paginationPageSize, searchValue]);

  useEffect(() => {
    props.setBreadcrumbItems("Invoices", breadcrumbItems);
    // const body = {
    //   page: page,
    //   limit: paginationPageSize,
    // }
    // if (!effectCalled.current) {
    //   getListOfRowData(body);
    //   effectCalled.current = true;
    // }
  }, []);

  useEffect(() => {
    const body = {
      page: page,
      limit: paginationPageSize,
    }
    if (searchValue) {
      body.search_text = searchValue;
    }
    if (sortBody) {
      body.sort = sortBody;
    }
    getListOfRowData(body);
  }, [searchValue, page, paginationPageSize, sortBody])

  // useEffect(() => {
  //   props.setBreadcrumbItems("Invoices", breadcrumbItems);
  //   if (customer && customer !== undefined && customer !== "") {
  //     let bodyObjectWithCategory = { ...bodyObjectReq };
  //     bodyObjectWithCategory.filter = {};
  //     bodyObjectWithCategory.filter.customer_name = customer;
  //     getListOfRowData(bodyObjectWithCategory);
  //   } else {
  //     let bodyObjectWithCategory = { ...bodyObjectReq };
  //     delete bodyObjectWithCategory["filter"];
  //     getListOfRowData(bodyObjectWithCategory);
  //   }
  // }, [customer]);

  // useEffect(() => {
  //   const body = {
  //     page: page,
  //     limit: paginationPageSize,
  //   }
  //   if (delaySearch && delaySearch !== undefined && delaySearch !== "") {
  //     let bodyObjectWithCategory = { ...body };
  //     bodyObjectWithCategory.search_text = delaySearch;
  //     getListOfRowData(bodyObjectWithCategory);
  //   } else {
  //     getListOfRowData(body);
  //   }
  // }, [delaySearch, page, paginationPageSize]);

  // useEffect(() => {
  //   props.setBreadcrumbItems("Invoices", breadcrumbItems);
  //   if (paginationPageSize && paginationPageSize !== undefined) {
  //     let bodyObjectWithCategory = { ...bodyObject };
  //     // bodyObjectWithCategory.limit=
  //     getListOfRowData(bodyObjectWithCategory);
  //   }
  // }, [paginationPageSize]);

  const handleChange = (e) => {
    setCustomer(e.target.value);
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value)
    // setSearchValue(e.target.value);

    // const delay = 2000;

    // const timerId = setTimeout(() => {
    //   console.log("Executing code after delay");
    //   setDelaySearch(e.target.value);
    //   setPage(1)
    //   setRowData([])
    // }, delay);

    // return () => clearTimeout(timerId);
  };

  const handleSearch = (event) => {
    setSearchValue(event.target.value);
    console.log(event.target.value);
    setPage(1);
    setRowData([]);
  }

  /*
const onGridReady = useCallback((params) => {
  setGridApi(e.api);
    createItemReq
      .then((resp) => resp.json())
      .then((data) => {
        // add id to data
        var idSequence = 1;
        data.forEach(function (item) {
          item.id = idSequence++;
        });
        // setup the fake server with entire dataset
        var fakeServer = new FakeServer(data);
        // create datasource with a reference to the fake server
        var datasource = getItemsReq(fakeServer);
        // register the datasource with the grid
        params.api.setGridOption('serverSideDatasource', datasource);
      });
  }, []);
*/

  const downloadOrdersExcel = async () => {
    try {
      setIsExporting(true);

      let body = {
        page: 1,
        limit: 200,
        sort: {
          key: 'date',
          order: 'A',
        },
      };

      if (new Date(body.startDate) > new Date(body.endDate)) {
        toast.error('From Date cannot be after To Date');
        return;
      }

      if (fromDate && toDate) {
        body.startDate = parseDateToISOStart(fromDate);
        body.endDate = parseDateToISOEnd(toDate);

        if (!body.startDate || !body.endDate) {
          toast.error('Invalid date format');
          return;
        }
      }

      const data = await getInvoicesReq(body);

      if (data?.length) {
        const flatInvoices = data.map(invoice => ({
          'Invoice Date': invoice.date,
          'Invoice No': invoice.invoice_number,
          'Order No': invoice.reference_number,
          Client: invoice.customer_name,
          Status: invoice.status,
          'Due Date': invoice.due_date,
          Total: invoice.total,
          'Amount Due': invoice.balance,
        }));

        const worksheet = XLSX.utils.json_to_sheet(flatInvoices);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Invoices');

        XLSX.writeFile(workbook, 'InvoiceList.xlsx');
        toast.success('Invoices Exported Successfully!');
      } else {
        toast.info('No invoices found for selected date range');
      }
    } catch (error) {
      console.error(error);
      toast.error('Export failed');
    } finally {
      setIsExporting(false);
      setFromDate('');
      setToDate('');
    }
  };

  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest('.position-relative')) {
        setExportOpen(false);
      }
    };

    if (exportOpen) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [exportOpen]);

  return (
    <React.Fragment>
      <Modal
        isOpen={modal_standard}
        toggle={() => {
          tog_standard();
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            Confirm
          </h5>
          <button
            type="button"
            onClick={() => {
              setmodal_standard(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <h5>Are you sure you want to delete {currRowItem?.title} ? </h5>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setmodal_standard(false);
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
            onClick={() => {
              // deleteItem(currRowItem)
            }}
          >
            Delete
          </button>
        </div>
      </Modal>
      <div className="all-invoices">
        <Row>
          <Col className="col-12">
            <Card>
              <CardBody>
                <div className="button-section">
                  <div className="button-right-section">
                    <div className="invoice-search-box">
                      <div className="search-box position-relative" style={{ width: auth.userType === USER_TYPES_ENUM.ADMIN ? '20rem' : '14rem' }}>
                        <Input
                          type="text"
                          // value={searchValue}
                          value={inputValue}
                          onChange={handleInputChange}
                          onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                              handleSearch(event);
                            }
                          }}
                          className="form-control rounded border"
                          placeholder={auth.userType === USER_TYPES_ENUM.ADMIN ? "Search by Client or Invoice Number" : "Search by Invoice Number"}
                        />
                        <i className="mdi mdi-magnify search-icon"></i>
                      </div>
                    </div>
                    {/* <select
                      onChange={handleChange}
                      id="customer"
                      name="customer"
                      value={customer}
                      className="form-select focus-width"
                    >
                      <option value="" selected>
                        Select Client
                      </option>
                      {allCustomers.map((e) => (
                        <option value={e}>{e}</option>
                      ))}
                    </select> */}
                  </div>
                  <div className="position-relative">
                    <StyledButton
                      color="primary"
                      className="w-md"
                      onClick={() => setExportOpen(prev => !prev)}
                    >
                      <div>
                        <i className="ion ion-md-cloud-download mx-2"></i>
                        Export
                      </div>
                    </StyledButton>

                    {exportOpen && (
                      <div
                        className="position-absolute bg-white border rounded shadow p-3"
                        style={{
                          right: 0,
                          top: '110%',
                          zIndex: 1000,
                          minWidth: '280px',
                        }}
                      >
                        <p className="fw-semibold mb-3">Export Invoices</p>

                        {/* FROM DATE */}
                        <div className="mb-2">
                          <label className="form-label mb-1">From Date</label>
                          <Input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                          />
                        </div>

                        {/* TO DATE */}
                        <div className="mb-3">
                          <label className="form-label mb-1">To Date</label>
                          <Input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                          />
                        </div>

                        <div className="d-flex justify-content-end gap-2">
                          <button
                            className="btn btn-light btn-sm"
                            onClick={() => {
                              setExportOpen(false);
                              setFromDate('');
                              setToDate('');
                            }}
                          >
                            Cancel
                          </button>

                          <button
                            className="btn btn-primary btn-sm"
                            disabled={!fromDate || !toDate}
                            onClick={() => {
                              if (new Date(fromDate) > new Date(toDate)) {
                                toast.error('From Date cannot be after To Date');
                                return;
                              }
                              setExportOpen(false);
                              downloadOrdersExcel();
                            }}
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="ag-theme-quartz"
                  style={{
                    height: "500px",
                    width: "100%",
                  }}
                >
                  <RequireUserType userType={USER_TYPES_ENUM.ADMIN}>
                    <AgGridReact
                      ref={gridRef}
                      rowHeight={60}
                      columnDefs={columnDefs}
                      pagination={pagination}
                      paginationPageSize={paginationPageSize}
                      paginationPageSizeSelector={paginationPageSizeSelector}
                      reactiveCustomComponents
                      autoSizeStrategy={autoSizeStrategy}
                      rowData={rowData}
                      defaultColDef={{ resizable: false, suppressMovable: true }}
                      onPaginationChanged={onPaginationChanged}
                    ></AgGridReact>
                  </RequireUserType>
                  <RequireUserType userType={USER_TYPES_ENUM.CLIENT}>
                    <AgGridReact
                      ref={gridRef}
                      rowHeight={60}
                      columnDefs={clientColumnDefs}
                      pagination={pagination}
                      paginationPageSize={paginationPageSize}
                      paginationPageSizeSelector={paginationPageSizeSelector}
                      reactiveCustomComponents
                      autoSizeStrategy={autoSizeStrategy}
                      rowData={rowData}
                      defaultColDef={{ resizable: false, suppressMovable: true }}
                      onPaginationChanged={onPaginationChanged}
                    ></AgGridReact>
                  </RequireUserType>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(AllInvoices);

